import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { interval, Subscription } from 'rxjs';
import { mergeMap, throttle } from 'rxjs/operators';
import { CommonUtils, CursorPosition } from '../../utils/common';
import { WebDataApiService } from 'src/app/service/server/web-data-api-service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { EndpointConfig } from 'src/app/config/endpoint-config';

@Component({
  selector: 'app-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.css']
})
export class ZoomComponent implements OnInit, OnDestroy, OnChanges {
  @Input('imgSrc')
  imgSrc: string
  @Input('position')
  position$: EventEmitter<CursorPosition>
  @Input('mag')
  mag: number

  @ViewChild('largeImage')
  largeImage: ElementRef<HTMLDivElement>
  @ViewChild('mouseTracker')
  mouseTracker: ElementRef<HTMLDivElement>

  isShow = true
  img: HTMLImageElement
  ctx: CanvasRenderingContext2D

  unsubscribers: Subscription[] = []

  constructor(
    private logger: NGXLogger,
    private webDataApiService: WebDataApiService,
    private endpointConfig: EndpointConfig,
    private http: HttpClient,
  ) { }

  ngOnInit() {
    this.isShow = true
    this.img = new Image()
    this.img.onload = () => {
      this.isShow = false
      this.largeImage.nativeElement.style.background = `url(${this.img.src}) no-repeat 0 0 scroll`
      this.largeImage.nativeElement.style.backgroundPosition = `${0.5 * 100}% ${0 * 100}%`

      this.unsubscribers = [
        this.position$.pipe(throttle(() => interval(10))).subscribe(p => {
          this.mouseTracker.nativeElement.style.left = `${p.x * 100}%`
          this.mouseTracker.nativeElement.style.top = `${p.y * 100}%`
          this.largeImage.nativeElement.style.backgroundPosition = `${p.x * 100}% ${p.y * 100}%`
        })
      ]
    }

    this.logger.info('Zoom for:', this.imgSrc)
    let documentId = this.imgSrc.split('?')[0].split('/').slice(-1)[0];
    let collectionPath = CommonUtils.getUDPImageCollectionPath(this.imgSrc);
    let params = new HttpParams().set('collectionPath', collectionPath).set('size', "L")
    this.webDataApiService.getUDPImageInfo([documentId], { params: params })
    .pipe(
      mergeMap(udpImageResponse => {
        let signedUrlData = udpImageResponse.signedUrls[0]
        let signedUrl = this.endpointConfig.riaApi.webData.udp.signedImage.getUrl(signedUrlData.signedUrl)
        return this.http.get(signedUrl, { responseType: 'blob' })
      })
      )
    .subscribe((blob) => {
      let objectUrl = URL.createObjectURL(blob);
      this.img.src = objectUrl
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.imgSrc && !changes.imgSrc.firstChange) {
      this.ngOnDestroy()
      this.ngOnInit()
    }
  }

  ngOnDestroy() {
    if (this.img.src) {
      URL.revokeObjectURL(this.img.src);
      this.img.src = ''
    }
    this.largeImage.nativeElement.style.background = ``
    this.unsubscribers.forEach(x => x.unsubscribe())
  }

  zoomIn() {
    if (!this.mag) {
      this.mag = (this.img.naturalWidth / this.largeImage.nativeElement.clientWidth) * 100
      this.logger.debug('init mag:', this.mag)
    }

    if (this.mag > 1000) {
      return
    }
    this.mag += 100
  }

  zoomOut() {
    if (!this.mag) {
      this.mag = (this.img.naturalWidth / this.largeImage.nativeElement.clientWidth) * 100
      this.logger.debug('init mag:', this.mag)
    }

    this.mag -= 100

    if (this.mag < 100) {
      this.mag = 100
    }
  }
}
